module.exports = `<!DOCTYPE html>
<head>
    <title>Customer Support Analyst</title>
    <style>
            body {
                font-family: Helvetica, sans-serif;
                text-align: left;
            }

            a:link {
                text-decoration: none;
                color: #FFFFFF;
            }

            a:visited {
                text-decoration: none;
                color: #FFFFFF;
            }

            a:hover {
                text-decoration: none;

            }

            a:active {
                text-decoration: none;
            }

            .prism-left {
                float:left!important
            }

            [class*="col-"] {
                width: 100%;
                float: left;
                padding: 15px;
                border: 0;
            }

            @media only screen and (min-width: 600px) {
            /* For tablets: */
                .col-s-1 {width: 8.33%;}
                .col-s-2 {width: 16.66%;}
                .col-s-3 {width: 25%;}
                .col-s-4 {width: 33.33%;}
                .col-s-5 {width: 41.66%;}
                .col-s-6 {width: 50%;}
                .col-s-7 {width: 58.33%;}
                .col-s-8 {width: 66.66%;}
                .col-s-9 {width: 75%;}
                .col-s-10 {width: 83.33%;}
                .col-s-11 {width: 91.66%;}
                .col-s-12 {width: 100%;}
            }

            @media only screen and (min-width: 768px) {
            /* For desktop: */
                .col-1 {width: 8.33%;}
                .col-2 {width: 16.66%;}
                .col-3 {width: 25%;}
                .col-4 {width: 33.33%;}
                .col-5 {width: 41.66%;}
                .col-6 {width: 50%;}
                .col-7 {width: 58.33%;}
                .col-8 {width: 66.66%;}
                .col-9 {width: 75%;}
                .col-10 {width: 83.33%;}
                .col-11 {width: 91.66%;}
                .col-12 {width: 100%;}
            }

            .row::after {
                content: "";
                clear: both;
                display: table;
            }

            .menubar {
                background-color: #505050;
            }

            .menuitem {
                color: #FFFFFF;
            }

            .sidebar {
                display: block;
                float: left;
                height: 100vh;
                background-color: #C0C0C0;
            }

            .sidebaritem {
                display: block;
                color: #000000;
            }

            .note {
                display: block;
                padding: 10px;
            }

            /* background-color: #607d8b; */
            .header, .footer {
                color: #FFFFFF;
                background-color: #000000;
                width: 100%;
                display: inline-block;
                padding-left: 10px;
                text-align: left;
            }

            .toplink {
                display: inline-block;
                background-color: #A0A0A0;
            }

            .section {
                display: block;
            }

            .diagram {
                display: inline-block;
            }

            .ui_datamodel {
                display: inline-block;
            }

            .explainer {
                display: inline-block;
            }

            .hdrtext {
                padding: 20px;
            }

            .caption {
                font-size: smaller;
                font-weight: bold;
                padding-left: 20px;
                text-align: left;
            }

            .telimgleft {
                display: inline-block;
                float: left;
            }

            .telimgright {
                display: inline-block;
                float: right;
            }
    </style>
</head>
<body>

<div class="header" id="topbanner">
    <img src="images/csa_hub/Trojan_Logo.png" alt="Trojan Energy Limited" class="prism-left" width="250px" style="padding:20px;" />
    <div class="hdrtext">
        <h1>CSAIP</h1>
        <h2>Customer Support Analyst Information Portal</h2>
    </div>
</div>

<div class="menubar row" style="width:100%;" id="menubar1">
    <div id="sdButton" class="col-1 col-s-1 menuitem"><a href="#sd_text" class="w3-button">System Definition</a></div>
    <div id="uxButton" class="col-1 col-s-1 menuitem"><a href="#ux_text" class="w3-button">User Experience</a></div>
    <div id="stButton" class="col-1 col-s-1 menuitem"><a href="#st_text" class="w3-button">Software Toolkit</a></div>
    <div id="trButton" class="col-1 col-s-1 menuitem"><a href="#tr_text" class="w3-button">Troubleshooting</a></div>
</div>

<div class="sidebar prism-left col-2 col-s-2" id="sidebar1">
    <nav>
        <h3>Toolkit</h3>
        <ul>
        <li><a href="https://portal.trojanenergyltd.com/admin" target="_blank" style="color:#000000;">Admin Portal</a></li>
        <li><a href="https://portal-orion-dot-trojan-tcs-csms-prod.nw.r.appspot.com/login" target="_blank" style="color:#000000;">ORION Ticketing System</a></li>
        </ul>
    </nav>

     <nav>
        <h3>Troubleshooting</h3>
        <b>Alerts (on portal)</b>
        <br />
        <a href="#fa_text">Flood Alert</a>
        <br />
        <a href="#lf_text">Lock Failed</a>
        <br />
        <a href="#il_text">Init Lance Failed</a>
        <br />
        <a href="#wl_text">Waiting Lance State</a>
        <br />
        <a href="#ch_text">CS Heartbeat/Status</a>
        <br />
        <a href="#hh_text">Hydra Heartbeat/Status</a>
        <br />
        <a href="#zc_text">EV Active for more than 10 minutes without charging</a>
        <br />
        <a href="#ee_text">Location CSxx charging - system error</a>
        <br />
        <br />
        <b>Observations (monitoring of charge sessions)</b>
        <br />
        <a href="#oc_text">CS Occupied Not Charging</a>
        <br />
        <a href="#zc_text">Zero Consumption</a>
        <br />
        <a href="#ct_text">Charging Terminated</a>
        <br />
        <br />
        <br />
        <b>Customer Reports (call/email from Customers)</b>
        <br />
        <a href="#ls_text">Lance Stuck - at beginning of charging session</a>
        <br />
        <a href="#ls_text">Lance Stuck - after car has finished charging</a>
        <br />
        <a href="#ld_text">Lance Not Detected in CS</a>
        <br />
        <br />
        <br />
        <b>Other Tasks</b>
        <br />
        <a href="#ej_text">Eject Lance</a>
        <br />
        <a href="#en_text">Enable Charge Station</a>
        <br />
    </nav>
</div>

<div class="section col-9 col-s-9" id="sd_text">
    <div class="hdrtext">
        <h2>Trojan Energy Hub</h2>
    </div>
    <div>
        <div class="note">
            <p>The core offering from Trojan Energy is the HUB. A network of 15 chargepoints tied back to a central cabinet (the hub). Within the cabinet is
            a modular layout of safety / control / communications equipment. There is an Industrial Personal Computer within the cabinet running the Hydra
            application software. Hydra communicates to each of the chargepoints and relays information back to the central control system in the cloud via a
            4G modem.</p>
        </div>
        <div class="diagram col-9 col-s-9" id="hub_schematic">
            <img class="telimgleft" src="images/csa_hub/Hub-System-Schematic-01.png" alt="Hub Components" max-width="100%" height="300px"/>
        </div>
        <div class="note">
            <p>At any Trojan HUB location the cabinet is typically installed in a position where it presents the lowest impact on the public thoroughfare.
            A connection to the National Grid is made within the cabinet (referred to as the 'cut-out'). Power cables and communications cables are then
            run under the pavement to the selected chargepoint locations. Here a Base Unit is concreted into the ground and the cables are terminated into
            a junction box.</p>
            <p>At this stage of installation the Cartridges, the active components of the chargepoint, can be dropped into and locked into place within
            a Base Unit. This combination of Base Unit / Cartridge is sometimes referred to as a Phalanx / Chargepoint / Charge Station.</p>
        </div>
        <div class="diagram col-9 col-s-9" id="hub_schematic">
            <p>Chargepoints are installed approximately 5m apart from each other (the exact details are very much dependent on the location) but they are
            NOT in dedicated parking spots. It is possible, and indeed very common, for the chargepoints to be blocked by Petrol / Diesel vehicles. This is
            a phenomenon known as being ICED (Internal Combustion Engine'd).</p>
            <img class="telimgright" src="images/csa_hub/Hub-System-01.png" alt="Hub Layout" max-width="100%" height="500px"/>
            <img class="telimgleft" src="images/csa_hub/Hub-System-On-Street-01.png" alt="Hub Layout" max-width="100%" height="500px"/>
        </div>
    </div>
    <br />
    <br />
    <div>
        <button type="button" class="toplink"><a href="#topbanner">RETURN TO TOP</a></button>
    </div>
</div>

<div class="section col-9 col-s-9" id="ux_text">
    <div class="hdrtext">
        <h2>User Experience</h2>
    </div>
    <div>
        <div class="note">
            <p>The user interface to the system is their Lance. This can be considered very much like a plug that is inserted into the chargepoint. Each
            lance has it's own unique identifier (UID) and each lance is allocated to a specific user. The lance is the means by which a user is recognised
            on the network and how their account is charged for the electricity that they receive. It is important to remember this and consider a lance
            with the same sensitivity as a customer's debit / credit card.</p>
        </div>
        <h3>Normal Connection Sequence</h3>
        <table>
            <tr>
                <td><img class="telimgleft" src="images/csa_hub/IMG001.png" alt="System Idling" max-width="100%" height="300px"><figcaption>System Idling<br/><i>Idling</i></figcaption></img></td>
                <td><img class="telimgleft" src="images/csa_hub/IMG003.png" alt="User Presents Lance" max-width="100%" height="300px"><figcaption>User Presents Lance<br/><i>Halls Detected</i></figcaption></img></td>
                <td><img class="telimgleft" src="images/csa_hub/IMG008.png" alt="User Inserts Lance" max-width="100%" height="300px"><figcaption>User Inserts Lance<br/><i>WaitingLance<br/>Lance Inserted<br/> Grabbing(Freeing)<br/>Updating Occupied <br/>Authorising</i></figcaption></img></td>
                <td><img class="telimgleft" src="images/csa_hub/IMG011.png" alt="User Raises Handle" max-width="100%" height="300px"><figcaption>User Raises Handle<br/><i>Waiting Pole Raised</i></figcaption></img></td>
                <td><img class="telimgleft" src="images/csa_hub/Ioniq5-Charging.png" alt="User Plugs-In EV" max-width="100%" height="300px"><figcaption>User Plugs-In EV<br/><i>B1State</i></figcaption></img></td>
                <td><img class="telimgleft" src="images/csa_hub/Ioniq5-Charging.png" alt="User Plugs-In EV" max-width="100%" height="300px"><figcaption>CSMS allocates charge profile<br/><i>B2State</i></figcaption></img></td>
                <td><img class="telimgleft" src="images/csa_hub/Ioniq5-Charging.png" alt="User Plugs-In EV" max-width="100%" height="300px"><figcaption>Car Charging<br/><i>EvReady</i><br/><i>C2State</i></figcaption></img></td>
            </tr>
        </table>
        <h3>Normal Disconnection Sequence</h3>
        <table>
            <tr>

                <td><img class="telimgleft" src="images/csa_hub/Ioniq5-Charging.png" alt="User Presents Lance" max-width="100%" height="300px"><figcaption>EV Finished Charging<br/><i>EvNotReady</i><br/><i>B2State</i></figcaption></img></td>
                <td><img class="telimgleft" src="images/csa_hub/IMG011.png" alt="User Disconnects EV" max-width="100%" height="300px"><figcaption>User Disconnects EV<br/><i>A2State</i><br/><i>Waiting Pole Dropped</i></figcaption></img></td>
                <td><img class="telimgleft" src="images/csa_hub/IMG008.png" alt="User Drops Handle" max-width="100%" height="300px"><figcaption>User Drops Handle<br/><i>Charge Station unlocks<br/>allowing Lance to be removed</i></figcaption></img></td>
                <td><img class="telimgleft" src="images/csa_hub/IMG003.png" alt="User Removes Lance" max-width="100%" height="300px"><figcaption>User Removes Lance<br/><i>Halls Lost Lance</i><br/><i>Finalising</i><br/><i>WaitingLockopen</i><br/><i>Reclosing</i></figcaption></img></td>
                <td><img class="telimgleft" src="images/csa_hub/IMG001.png" alt="System Idling" max-width="100%" height="300px"><figcaption>System Idling</figcaption></img></td>
            </tr>
        </table>
    </div>
    <br />
    <br />
    <div>
        <button type="button" class="toplink"><a href="#topbanner">RETURN TO TOP</a></button>
    </div>
</div>

<div class="section col-9 col-s-9" id="ux_text">
    <div class="trtext">
        <h2>Software Toolkit</h2>
            <p>Your tools for monitoring sessions / system health / intervening when there is an issue.</p>
    </div>
    <div class="note">
        <p><b>Admin Portal</b></p></p>https://portal.trojanenergyltd.com/admin</p>
    <p>All of the system monitoring and intervention when an issue arises can be done from the portal.</p></div>
    <div class="note">
        <p><b>ORION</b></p></p>https://portal-orion-dot-trojan-tcs-csms-prod.nw.r.appspot.com/login</p>
        <p>The ticketing system ORION is used to track and record all system issues whether they are customer reported or observations / interventions made by a Support Analyst.<p></div>
    <div class="note">
        <p><b>Google Chat</b></p>
        <p>In order to keep all of the relevant parties in Trojan Energy Limited appraised of ongoing incidents issues, transcribe the key details to the correct chat group:</p>
        <p>Technical Support : Location, time, chargepoint(s), nature of the fault, whether intervention is required.</p>
        <p>Customer Support : Location, time, customer, whether there is to be an intervention by the technical team, whether the customer needs to be contacted.</p>
    </div>
    <br />
    <br />
    <div>
        <button type="button" class="toplink"><a href="#topbanner">RETURN TO TOP</a></button>
    </div>
</div>

<div class="section col-9 col-s-9" id="tr_text">
    <div class="trtext">
        <h2>Standard EV Charging Sequence / State</h2>
    </div>
    <div>
        <ul>
            <li>A1 : No EV present, system idling, CSMS not offering power.
            <li>B1 : EV plugged in, CSMS yet to offer power.
            <li>C1 : EV plugged in, EV ready to receive charge, CSMS yet to offer power.
            <li>A2 : No EV present, CSMS offering power.
            <li>B2 : EV plugged in, EV not ready, CSMS offering power.
            <li>C2 : EV plugged in, EV ready, CSMS offering power.
        </ul>
     </div>
</div>

<div class="section col-9 col-s-9" id="tr_text">
    <div class="trtext">
        <h2>Troubleshooting</h2>
    </div>

    <div class="note">
        <h3>Alerts</h3>
    </div>
    <div class="note" id="fa_text">
        <h4>Flood Alert (Water Ingress)</h4>
    </div>
    <div>
        <ol>
            <li>Update <b>Tech Support Google Chat</b>. Flood alert on <i>Location CSxx</i>. Shutting it down.</li>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and then Charge Station to go to Charge Station screen</li>
            <li><b>Set charge station LEDs to red</b> and verify you see Charge Station Stopped in Logs section</li>
            <li><b>Stop Charge Station</b> and verify you see Charge Station Stopped in Logs section</li>
            <li><b>Disable Charge Station</b></li>
            <li>Go to <b>Hydras</b> screen and refresh - check charge station is showing as Stopped</li>
            <li>Go to <b>Charge station</b> screen</li>
            <li>Raise ORION ticket with relevant details
            <br /><i>Ticket_datetime: (time of alert)
            <br />Event Type: Water Ingress
            <br />Description : Flood alert on <i>Location CSxx</i>. Shut down and disabled.</i></li>
        </ol>
    </div>
    <br />
    <div class="note" id="lf_text">
        <h4>Lock Failed</h4>
    </div>
    <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Click <b>Stop Charge Station</b>  (verify stopped via logs - TBC if change implemented yet)</li>
            <li>Click <b>Start Charge Station</b></li>
            <li>Check status when charge station restarts</li>
            <ul>
                <li>BootingCovered -> Authorising -> B1 -> B2 -> C2 and consumption > 0
                <br />
                Means car is charging successfully
                </li>
                <li>BootingNotCovered -> Managing Mess State
                <br />
                Looks like charge station is stuck down and will require Technician to go to site
                <ul>
                <li>Add to <b>Tech Support Google Chat</b> to ask Technician to go to <i>Location CSxx</i> as suspect charge station stuck down</li>
                <li>Technician arrives on site then follow Column Retained instructions</li>
                </ul>
                </li>
            </ul>
            <li>Raise ORION ticket with relevant details
            <br /><i>Ticket_datetime: (time of alert)
            <br />Event Type: Lock Mechnism Failure
        </ol>
    </div>
    <br />
    <div class="note" id="cr_text">
        <h4>Column Retained</h4>
    </div>
    <div>
        <ol>
            <li>On site technician performs visual check on charge station and uploads photo to Tech Support chat</li>
            <li>Technician confirms contacts ok</ii>
            <ul>
                <li>Go to <b>Admin Portal</b></li>
                <li>Select <b>Hydras</b> from menu </ii>
                <li>Select Location and and then Charge Station to go to Charge Station screen</li>
                <li>Technician on-site confirms they are next to charge station</li>
                <li>Click <b>Eject Lance</b></li>
                 <li>Confirm with Technician that charge station has returned to the top</li>
                    <ul>
                        <li>Charge Station returned to top</li>
                        <ul>
                            <li>Refresh Charge Station screen by changing no of log entries to view</li>
                            <li>Check states -> Top Y, Btm N, Closed Y, Open N</li>
                            <li>If Closed = N, Open = Y then click <b>Lock Cartridge</b></li>
                        </ul>
                        <li>Charge station fails to return to top</li>
                        <ul>
                            <li>Refresh charge station screen by changing no of log entries to view.</li>
                            <li>Within hours</li>
                                <ul>
                                    <li>Cartridge Replacement</li>
                                </ul>
                            <li>Out of Hours</li>
                                <ul>
                                    <li>Get technician to retrieve spare lance from nearby cabinet</li>
                                    <li>Insert lance into charge station and see if can make bottom switch</li>
                                    <li>From charge station screen, click <b>Lock Cartridge</b></li>
                                    <li>Should lock Lance in place until such time cartridge can be replaced</li>
                                </ul>
                            <li></li>
                        </ul>
                    </ul>
            </ul>
            <li>Technician identifies contacts are broken - ensure clear photo/video taken of contacts inside cartridge</li>
                <ul>
                    <li>Within hours - Cartridge Replacement</li>
                    <li>Out of Hours - Cover charge station if possible, Technican to isolate charge station</li>
                </ul>
            <li>Update ORION ticket</li>
        </ol>
    </div>
    <br />
    <div class="note"  id="il_text">
        <h4>Init Lance Failed</h4>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and then Charge Station to go to Charge Station screen</li>
            <li>Click <b>Lock Cartridge</b></ii>
            <li>Wait 10 seconds to allow lock command to get through</li>
            <li>Click <b>Stop Charge Station</b></li>
            <li>Click <b>Start Charge Station</b></li>
            <li>Check logs to see status</li>
            <ul>
                <li>BootingCovered -> Authorising -> B1 -> B2 -> C2 and consumption > 0
                <br />
                Means car is charging successfully
                </li>
                <ul>
                    <li>Raise ORION ticket - Event Type - Init Lance Failed</li>
                </ul>
                <li>BootingNotCovered -> Managing Mess State</li>
                    <ul>
                        <li>Repeat LOCK / START / STOP steps another time</li>
                        <li>If fails again then require to call out Technician</li>
                        <li>Raise ORION ticket - Event Type - Init Lance Failed</li>
                        <li>Add to <b>Tech Support Chat</b> ask Technician to go to Location CS and require to remove lance and re-insert</li>
                        <li>When technician arrives on site and confirms at charge point, click Eject Lance</li>
                        <li>Update ORION ticket</li>
                    </ul>
            </ul>
        </ol>
    </div>
    <div class="note" id="wl_text">
        <h4>Waiting Lance state for more than x seconds</h4>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Click <b>Stop Charge Station</b> - wait for charge station to stop</ii>
            <li>Click <b>Start Charge Station</b></li>
            <li>Check logs to see status</li>
            <ul>
                <li>InitCartirdge and never moves on</li>
                    <ul>
                        <li>Requires a restart of the Hydra software/li>
                        <li>This can only be done if no-one else is actively charging at that location</li>
                        <li>Add to <b>Tech Support Chat</b> that require a Hydra Software restart at Location</li>
                        <li>Raise ORION ticket  - Btm Switch Not Set</li>
                    </ul>
                </li>
                <li>InitCartridge -> BootingCoveredPending -> ....moves on to any other state e.g Idling
                <br />
                Charge station has started successfully
                </li>
                <ul>
                    <li>From charge station screen, check states. If Closed = N then click <b>Lock Cartridge</b></li>
                    <li>Raise ORION ticket - Event Type - Btm Switch Not Set</li>
                </ul>
            </ul>
        </ol>
    </div>
    <div class="note"  id="ch_text">
        <h4>CS not sent heartbeat/status polling error</h4>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Click <b>Stop Charge Station</b> - wait for charge station to stop</ii>
            <li>Click <b>Start Charge Station</b></li>
            <li>Check logs to see status returns to Idling</li>
            <li>If it doesn’t add to Tech Support Chat that require Tech Support to restart Hydra software at Location</li>
            <li>Raise ORION ticket - Event Type: Not Determined. Will be updated once cause is determined</li>
        </ol>
    </div>
    <br />
    <div class="note"  id="hh_text">
        <h4>Hydra not sent heartbeat/status polling error</h4>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Check last hearbeat time of any charge station</ii>
            <li>Add to Tech Support Chat that require Tech Support (Tom/Sandy/Carol) to see if they can remotely access the Hydra. They will then ask someone to attend if they can't acess the IPC on the Hydra</li>
            <li>Raise ORION ticket - Event Type: Not Determined. Will be updated once cause is determined</li>
        </ol>
    </div>
     <div class="note"  id="ee_text">
        <h4>Location xx charging but something has caused the system to error</h4>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Check logs for charge station</ii>
            <li>Add to Tech Support Chat that require Tech Support (Tom/Sandy/Carol) to check logs on Hydra for timestamp of alert</li>
            <li>Raise ORION ticket - Event Type: Not Determined. Will be updated once cause is determined</li>
        </ol>
    </div>

    <div class="note">
        <h3>Observations</h3>
        Issues observed by monitoring the charge sessions
    </div>
    <div class="note"  id="oc_text">
        <h4>Charge Station shows as Occupied but no Active Charging session</h4>
    </div>
     <div>
        <ol>
            <li>Check current status</li>
                <ul>
                    <li>Waiting Lock Open State</li>
                    <li>Checking Actual State</li>
                    <li>Updating Occupied</li>
                    <li>Waiting Pole Dropped</li>
                    <li>Waiting Pole Raised</li>
                    <li>Lance Inserted</li>
                </ul>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Click <b>Stop Charge Station</b> - wait for charge station to stop</ii>
            <li>Click <b>Start Charge Station</b></li>
            <li>Check logs to see what status charge station comes up in</li>
                <ul>
                    <li>Idling - check closed status - if closed = N then click <b>Lock Cartridge</b> and check closed changes to Y</li>
                    <li>Waiting Pole Raised - contact Customer to let them know they will need to remove Lance</li>
                    <li>Authorising -> B1 >-B2 -> C2 and consumption starts going up then all OK</li>
                </ul>
            <li>Raise ORION ticket - Event Type: Not Determined. Will be updated once cause is determined</li>
        </ol>
    </div>
    <br />
    <div class="note" id="zc_text">
        <h4>Zero consumption session after more than 5 minutes / EV session active over x minutes without charging</h4>
    </div>
     <div>
        <ol>
            <li>Check current status</li>
                <ul>
                    <li>Waiting Pole Dropped</li>
                    <ul>
                        <li>Go to <b>Admin Portal</b></li>
                        <li>Select <b>Hydras</b> from menu </ii>
                        <li>Select Location and and then Charge Station to go to Charge Station screen</li>
                        <li>Click <b>Stop Charge Station</b></li>
                        <li>Click <b>Start Charge Station</b></li>
                        <li>Check status</li>
                        <ul>
                            <li><b>WaitingPoleRaised</b> State then will timeout and go back to WaitingPoleDropped
                            <br/>
                            Means Customer did not pull handle of Lance up - check uplock flag on charge station screen.
                            <br />
                            Contact Customer to let them know car not charging and looks like handle on Lance is not Raised.
                            <br/>
                            (Anyone can remove it at this point so could stop charge station until Customer was available to  collect) </li>
                            <li><b>LancePresent -> C2 State </b>
                            <br/>
                            Means Customer possibly connected car after the timeout period.
                            </li>
                        </ul>
                    </ul>
                    <li>B2 State. Never got to C2 State</li>
                    <ul>
                        <li>Customer may have set it to delayed charge (Trojan app or car app) - this has been seen with some Tesla app users. No issue on our side but cannot tell.</li>
                        <li>EV connector may not be properly inserted into car - have seen occurrences of this></li>
                        <li>Lance may be faulty (rare)</li>
                        <li>Solution - contact Customer to let them know car is not charging and ask them to try unplugging from car, removing Lance and then trying again (Insert Lance, then plug into car) </li>
                    </ul>
                    <li>B2 State, briefly got to C2 State (one or more times)</li>
                    <ul>
                        <li>Go to relevant charge station</li>
                        <li>Click <b>Set charge profile to 0A </b> </li>
                        <li>Check status, should change B1 State</li>
                        <li>Wait 2 minutes</li>
                        <li>Click <b> Auto Charge Profile</b>, should change to B2 State <br/> NOTE: This may not give a high enough charge profile as may default to 8A after power drop outs. If so they click 'Set charge profile to 20A' or 'Set charge profile to 32A' based on what Customer charge profule normally is. This OVERRIDES CSMS arbirtation so need to be careful on which profile you send based on how many cars are plugged in. Max to be shared is 96A between all charge stations. If manally overridden then CSMS will not adjust automatically when another car plugs in</li>
                        <li>Check logs for EvReady and then attempt to C2</li>
                        <li>If this does not work then try a <b>Lock Cartridge</b> then repeat above (send 0A profile, wait few mins, send Auto Charge Profile)</li>
                        <li>If this does not work then normally an error on EV side and only way to resolve is to ask Customer to unplug from car, remove Lance and start session again.</li>
                    </ul>
                </ul>
            <li>Go to charge station for relevant location and charge station</li>
            <li>Raise ORION ticket - Event Type : (WaitingPoleDropped) : UserTraining  (B2/C2)Power Delivery Failure</li>
        </ol>
    </div>
    <br />
    <div class="note"  id="ct_text">
        <h4>Session terminated prematurely</h4>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Check Logs and Charge session graphs</li>
                <ul>
                    <br/>
                    <li>EvNotReady with no errors - car has decided to stop charging so no further action<br/>
                    <img src="images/csa_hub/PowerDropOKExample.png" alt="Car Not Ready"  width="500px" />
                    <br/></li>
                    <br/>
                    <li>Mains Not On Yet seconds before EvNotReady<br/>System has caused session to end prematurely<br/>
                    <img src="images/csa_hub/PowerDropIssueExample.png" alt="Car Not Ready"  width="500px" />
                    </li>
                    <br/>
                    <li>Multiple power drop outs<br/>
                    <img src="images/csa_hub/PowerDropMultipleExample.png" alt="Car Not Ready"  width="500px" />
                    </li>
                </ul>
             <li>Click <b>Set charge profile to 0A </b> </li>
            <li>Check status, should change B1 State</li>
            <li>Wait 2 minutes</li>
            <li>Click <b> Auto Charge Profile</b>, should change to B2 State <br/> NOTE: This may not give a high enough charge profile as may default to 8A after power drop outs. If so they click 'Set charge profile to 20A' or 'Set charge profile to 32A' based on what Customer charge profule normally is. This OVERRIDES CSMS arbirtation so need to be careful on which profile you send based on how many cars are plugged in. Max to be shared is 96A between all charge stations. If manally overridden then CSMS will not adjust automatically when another car plugs in</li>
            <li>Check logs for EvReady and then attempt to C2</li>
            <li>If this does not work then normally an error on EV side and only way to resolve is to ask Customer to unplug from car, remove Lance and start session again.</li>
            <li>Raise ORION ticket - Event Type : Charging Terminated</li>
        </ol>
    </div>
    <br />
     <div class="note">
        <h3>Customer Reports</h3>
        Issues customers may report (via call or email)
    </div>
    <div class="note"  id="ls_text">
        <h4>Lance Stuck - Customer is starting charge session</h4>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Click <b>Stop Charge Station</b> - wait for charge station to stop</ii>
            <li>Click <b>Start Charge Station</b></li>
            <li>Check logs to see status</li>
                <ul>
                    <li><b>EvInitial</b> State then will timeout and go back to WaitingPoleDropped</li>
                        <ul>
                            <li>Add to Customer Support chat that Lance is stranded in charge station with Customer name.
                            <br />
                            (Anyone can remove it at this point so could stop charge station until Customer was available to  collect)</li>
                        </ul>
                    </li>
                    <li><b>LancePresent -> C2 State</b>  WaitingPoleDropped</li>
                        <ul>
                            <li>Means Customer possibly connected car after the timeout period.</li>
                        </ul>
                    </li>
                </ul>
            <li>Raise ORION ticket - Event Type : Charging Terminated</li>
        </ol>
    </div>
    <br />
    <div class="note"  id="ls_text1">
        <h4>Lance Stuck - Customer is trying to remove lance after charge session</h4>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Check Customer is on site</ii>
            <li>If Customer confirms they are next to charge station click <b>Eject Lance</b> when Customer is ready
            <b><span style="color: red"><br/>NOTE - this should ONLY be done when Customer or Technician confirms they are next to charge station</span></b></li>
            <li>Confirm with Customer that the lance is out of charge station</li>
            <li>Click <b>Stop Charge Station</b> and verify you see Charge Station Stopped in Logs section</li>
            <li>Click <b>Start Charge Station</b></li>
            <li>Raise ORION ticket - Event Type : Charging Terminated</li>
        </ol>
    </div>
    <br />
    <div class="note"  id="ld_text">
        <h4>Charge Point Not Recognising Lance</h4>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Check Logs</ii>
                <ul>
                    <li>Unexpected hall byte errors (TBC when that will be available)</li>
                    <li>LanceInsertedState but btm Switch not going to Y</li>
                </ul>
            </li>
            <li><b>Stop Charge Station</b> and verify you see Charge Station Stopped in Logs section</li>
            <li><b>Disable Charge Station</b></li>
            <li>Raise ORION ticket - Event Type : Charging Terminated</li>
            <li>Add to <b>Tech Support chat</b> the issue with <i>Location CS</i></li>
        </ol>
    </div>
    <br />
     <div class="note">
        <h3>Other Tasks</h3>
    </div>
    <div class="note"  id="ej_text">
        <p>Eject Lance</p>
        <b><span style="color: red">NOTE - this should ONLY be done when Customer or Technician is on site</span></b>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Set Chargepoint to state B1 or C1 by changing Charge Profile to 0A </li>
            <li>Confirm Customer/Tehcnician is next to charge point</ii>
            <li>Click <b>Eject Lance</b></li>
            <li>Check logs to see status</li>
                <ul>
                    <li><b>Idling</b> - no further action</li>
                    <li><b>Any other state</b></li>
                        <ul>
                            <li>Click <b>Stop Charge Station</b></li>
                            <li>Click <b>Start Charge Station</b></li>
                            <li>Check status is Idling</li>
                            <li>On restart if closed=N then click <b>Lock Cartridge</b></li>
                            <li>Check closed=Y after Lock Cartridge</li>
                        </ul>
                    </li>
                </ul>
        </ol>
    </div>
    <br />
    <div class="note"  id="en_text">
        <h4>Enable Charge Station</h4>
    </div>
     <div>
        <ol>
            <li>Go to <b>Admin Portal</b></li>
            <li>Select <b>Hydras</b> from menu </ii>
            <li>Select Location and and then Charge Station to go to Charge Station screen</li>
            <li>Click <b>Enable Charge Station</b></ii>
            <li>Go back to Hydras screen and confirm the charge station now shows as Available (would have been Stopped before)</ii>
            <li>Go to charge station screen.</li>
            <li>Check Logs for charge station - if charge station was already running then should see it change from Booting Rejected to BootingPending and then Idling</li>
            <li>If not running then click <b>Start Charge Station</b></li>
            <li>Check Logs for charge station and make sure charge station is now starting and goes to Idling</li>
        </ol>
    </div>
    <br />
    <div>
        <button type="button" class="toplink"><a href="#topbanner">RETURN TO TOP</a></button>
    </div>
</div>

<div class="section col-9 col-s-9" id="tr_text">
    <div class="trtext">
        <h2>Glossary - Work in Progress - see Trojan Hub section</h2>
    </div>
    <div>
        <table>
            <tr>
            <td>Hydra</td><td>Cabinet on street connected to 15 charge points. A connection to the National Grid is made within the cabinet (referred to as the 'cut-out'). Power cables and communications cables are then run under the pavement to the selected chargepoint locations</td>
            </tr><tr>
            <td>Base Unit</td><td>Concreted into the ground. The underground cables fronm the cabinet are terminated into a junction box</td>
            </tr><tr>
            <td>Cartridge</td><td>The active component of the chargepoint, can be dropped into and locked into place within a Base Unit. Lance is inserted into the Cartridge</td>
            </tr><tr>
            <td>Charging Station</td><td>Combination of Base Unit / Cartridge is sometimes referred to as a Phalanx / Chargepoint / Charge Station</td>
            </tr><tr>
            <td>Lance</td><td>The user interface to the system is their Lance. This can be considered very much like a plug that is inserted into the chargepoint. Each
            lance has it's own unique identifier (UID) and each lance is allocated to a specific user. The lance is the means by which a user is recognised
            on the network and how their account is charged for the electricity that they receive. It is important to remember this and consider a lance
            with the same sensitivity as a customer's debit / credit card.</td>
            </tr><tr>
            <td>CSMS</td><td>Charge Station Management System (Google Cloud). Services that run in conjuction with Hydra software to operate the charge points</td>
            </tr>
        </table>
    </div>
</div>


</body>
</html>`;
